// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.checkout-personal-data-wrapper {
  padding: var(--spacing-regular);
  border-radius: var(--border-radius-secondary) !important;
  box-shadow: 0px 2px 8px 0px rgba(0, 0, 20, 0.12);
  background-color: var(--color-button-text);
  cursor: auto;
}
.checkout-personal-data-wrapper .checkout-personal-data-title {
  display: flex;
  align-items: center;
  gap: var(--spacing-extra-small);
  margin-bottom: var(--spacing-small);
}
.checkout-personal-data-wrapper .checkout-personal-data-title .vert-icon {
  cursor: auto;
}
.checkout-personal-data-wrapper .checkout-personal-data-title .vert-icon svg {
  width: 18px;
  height: 18px;
  fill: var(--color-neutral-dark-darker);
}
.checkout-personal-data-wrapper .checkout-personal-data-title .vert-title {
  font-size: var(--font-medium);
  font-weight: 600;
  line-height: 24px !important;
  margin: 0;
  text-align: left;
  cursor: auto;
}
.checkout-personal-data-wrapper .checkout-personal-data-content .vert-paragraph {
  font-size: var(--font-paragraph);
  font-weight: 400;
  line-height: 24px;
  cursor: auto;
}
.checkout-personal-data-wrapper .checkout-personal-data-content span {
  font-weight: 400;
}
@media screen and (max-width: 768px) {
  .checkout-personal-data-wrapper {
    padding: var(--spacing-small);
    background-color: var(--color-button-text);
  }
}
`, "",{"version":3,"sources":["webpack://./src/Assets/styles/default/components/Checkout/CheckoutPersonalDataStyles.less"],"names":[],"mappings":"AACA;EACI,+BAAA;EACA,wDAAA;EACA,gDAAA;EACA,0CAAA;EACA,YAAA;AAAJ;AALA;EAQQ,aAAA;EACA,mBAAA;EACA,+BAAA;EACA,mCAAA;AAAR;AAXA;EAcY,YAAA;AAAZ;AAdA;EAgBgB,WAAA;EACA,YAAA;EACA,sCAAA;AAChB;AAnBA;EAuBY,6BAAA;EACA,gBAAA;EACA,4BAAA;EACA,SAAA;EACA,gBAAA;EACA,YAAA;AADZ;AA3BA;EAkCY,gCAAA;EACA,gBAAA;EACA,iBAAA;EACA,YAAA;AAJZ;AAjCA;EAyCY,gBAAA;AALZ;AAWA;EACI;IACI,6BAAA;IACA,0CAAA;EATN;AACF","sourcesContent":["// DESKTOP\n.checkout-personal-data-wrapper {\n    padding: var(--spacing-regular);\n    border-radius: var(--border-radius-secondary) !important;\n    box-shadow: 0px 2px 8px 0px rgba(0, 0, 20, 0.12);\n    background-color: var(--color-button-text);\n    cursor: auto;\n\n    .checkout-personal-data-title {\n        display: flex;\n        align-items: center;\n        gap: var(--spacing-extra-small);\n        margin-bottom: var(--spacing-small);\n\n        .vert-icon {\n            cursor: auto;\n            svg {\n                width: 18px;\n                height: 18px;\n                fill: var(--color-neutral-dark-darker);\n            }\n        }\n\n        .vert-title {\n            font-size: var(--font-medium);\n            font-weight: 600;\n            line-height: 24px !important;\n            margin: 0;\n            text-align: left;\n            cursor: auto;\n        }\n    }\n\n    .checkout-personal-data-content {\n        .vert-paragraph {\n            font-size: var(--font-paragraph);\n            font-weight: 400;\n            line-height: 24px;\n            cursor: auto;\n        }\n\n        span {\n            font-weight: 400;\n        }\n    }\n}\n\n// MOBILE\n@media screen and (max-width: 768px) {\n    .checkout-personal-data-wrapper {\n        padding: var(--spacing-small);\n        background-color: var(--color-button-text);\n    }\n}\n\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
